import { makeActionCreator } from 'utils/reduxUtils/reduxUtils';

export const types = {
  FACEBOOK_INITIALISE: '@@jg/FACEBOOK_INITIALISE',
  UPDATE_FACEBOOK_LOGIN_STATUS: '@@jg/UPDATE_FACEBOOK_LOGIN_STATUS',
};

const actions = {
  addFacebookScript: (d, s, id) => {
    /* eslint-disable */
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    /* eslint-enable */
  },

  setFacebookLoginStatus: makeActionCreator(types.UPDATE_FACEBOOK_LOGIN_STATUS, 'facebookLoginStatus'),

  facebookInitialise: (appId) => (dispatch) => {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId,
        cookie: true,
        xfbml: true, // maybe set this to false after dev to see if everything still works
        version: 'v2.8',
      });
      window.FB.AppEvents.logPageView();

      dispatch({
        type: types.FACEBOOK_INITIALISE,
      });
      window.FB.getLoginStatus((response) => dispatch(actions.setFacebookLoginStatus(response)));
    };
    actions.addFacebookScript(document, 'script', 'facebook-jssdk');
  },
};


export default actions;



// WEBPACK FOOTER //
// ./actions/facebookActions/facebookActions.js